import { h } from '@stencil/core';
const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4998 18.6583L7.405 27.7531C6.80902 28.349 5.84276 28.349 5.24679 27.7531C4.65081 27.1571 4.65081 26.1908 5.24679 25.5949L14.3416 16.5L5.24679 7.40524C4.65081 6.80927 4.65081 5.843 5.24679 5.24703C5.84276 4.65106 6.80902 4.65106 7.405 5.24703L16.4998 14.3418L25.5946 5.24703C26.1906 4.65106 27.1569 4.65106 27.7528 5.24703C28.3488 5.843 28.3488 6.80927 27.7528 7.40524L18.658 16.5L27.7528 25.5949C28.3488 26.1908 28.3488 27.1571 27.7528 27.7531C27.1569 28.349 26.1906 28.349 25.5946 27.7531L16.4998 18.6583Z"
        fill="#F43A36"
      />
    </svg>
  );
};

export default Icon;
